export enum FilterOptionType {
    STANDARD,
    DATE_RANGE,
    CLIENT,
    USER
}